import getTotalRemainingHours from './getTotalRemainingHours';

export default (endTime: number, date: Date): number => {
  // Determine the number of days remaining
  return Math.floor(getTotalRemainingHours(endTime, date) / 24);
};
